const html = document.querySelector("html");
const body = document.querySelector("body");
const app = document.querySelector("#app");

const screenWidths = {
  xs: 375,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export default class Html {
  static init() {
    Html.detectInternetExplorer();
  }

  static detectInternetExplorer() {
    try {
      this.isIE10 = navigator.appVersion.indexOf("MSIE 10") !== -1;
    } catch (e) {
      this.isIE10 = false;
    }

    try {
      this.isIE11 = navigator.userAgent.indexOf("Trident") !== -1 && navigator.userAgent.indexOf("rv:11") !== -1;
    } catch (e) {
      this.isIE11 = false;
    }

    this.isIE = this.isIE10 || this.isIE11;

    if (this.isIE) {
      body.classList.add('ie');
    }

    if (this.isIE10) {
      body.classList.add('ie10');
    }

    if (this.isIE11) {
      body.classList.add('ie11');
    }
  }

  static html() {
    return html;
  }

  static body() {
    return body;
  }

  static app() {
    return app;
  }

  static windowHeight() {
    return window.innerHeight || document.documentElement.clientHeight|| Html.body().clientHeight;
  }

  static windowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || Html.body().clientWidth
  }

  static elementHeight(el) {
    el = typeof el === "string" ? document.querySelector(el) : el;

    let height;

    try {
      height = window.getComputedStyle(el, null).getPropertyValue("height");
    } catch (error) {
      height = el.currentStyle.height;
    }

    height = height.replace("px", "");

    return parseInt(height);
  }

  static elementHeightWithMargin(el) {
    el = typeof el === "string" ? document.querySelector(el) : el;

    const styles = window.getComputedStyle(el);

    const margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

    return Math.ceil(el.offsetHeight + margin);
  }

  static isScreen(screen) {
    return Html.windowWidth() >= screenWidths[screen];
  }
}
